module.exports = __webpack_public_path__ + "static/media/Jan_2026_4.ed2c0cb0.webp";